import { graphql } from "gql";
import request from "graphql-request";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const mutationCreateCustomPlanFromPlan = (
    accessToken: string,
    data: {
        carbonReductionPlanUid: string,
        planName: string
    }
) => 
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: mutationQuery,
        variables: {
            carbonReductionPlanUid: data.carbonReductionPlanUid,
            planName: data.planName,
        },
        requestHeaders: buildRequestHeaders(accessToken),   
    }).then((data) => {
        if (data) {
            return data;
        }
        throw new Error("Error creating custom plan");
    })
    .catch((error) => {
        console.error("GraphQL Error:", error);
        throw error; 
    });

const mutationQuery = graphql(`
    mutation createCustomPlanFromPlan ($carbonReductionPlanUid: Uuid!, $planName: String!) {
        createCustomPlanFromPlan (carbonReductionPlanUid: $carbonReductionPlanUid, planName: $planName)
    }
`);        

export default mutationCreateCustomPlanFromPlan;